import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";

function LinkExpiry() {
    const dispatch = useDispatch();
    const location: any = useLocation();
    const linkMessage = location && location.state && location.state?.linkMessage ? location.state?.linkMessage : "";

    const partnerPhone = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : "1-888-439-7443"
    );

    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [routeLoading]);
    return (
        <div className="container">
            <div className="row margin-vertical-xl">
                <div className="box col-xs-12 box-has-shadow box-lg">
                    
                    <div className="box-description mav-risk-not-found null-body-detected-breach">
                        <div className="row row-container">
                            <div className="col-sm-3"></div>
                            <div className="col-xs-12 col-sm-12 text-align-center col-main">
                                <span className="fs-26">
                                    <RenderIcons iconName="info-circle" />
                                </span>
                                <div>
                                    <div className="title-main mtb-1rem">{linkMessage}</div>
                                    <div className="description">
                                    Please contact member services at{" "}
                                        <a href={'tel:"' + partnerPhone + '"'}>
                                            {partnerPhone}
                                        </a>.
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-3"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LinkExpiry;
